import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { firestoreMethods } from '../../firebase/firestoreMethods';

import AdminHeader from '../AdminHeader';
import SubHeader from '../../SubHeader';
import SiteCard from './SiteCard';



function SiteView() {
  const { siteId } = useParams();
  const [ site, setSite ] = useState();

  // fetch site
  useEffect(() => {
    
    let active = true;
    const fetchSite = async () => {
      const newData = await firestoreMethods.getSite(siteId);
      if (active){
        setSite(newData);
      }
    };  

    fetchSite();
    
    return () => {
      active = false;
    };
  }, [siteId]);

  if (!site) return null;
  return (
    <>
      <AdminHeader/>
      <SubHeader nav={'/admin/sites'} display="Back to Sites"/> 

      <div className='view-site'>
        <SiteCard site={site}/>
      </div>
   </>
      
  );
}


export default SiteView;
